import { useDataValue } from 'Simple/Data.js'
import useStableValue from 'Logic/useStableValue.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  let parent_company_id = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'current_location.parent_company._id',
  })
  let term = useDataValue({
    viewPath: props.viewPath,
    context: 'professional_search',
    path: 'term',
  })
  let search_term = useStableValue(`%${term}%`)

  return {
    variables: {
      search_term,
      parent_company_id,
    },
    pause: search_term.length < 5,
  }
}
